import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { logout } from "../auth/logout";

const Navbar = () => {
  // Poll outstanding client notifications (e.g. new client comments) for the badge.
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    let stop = false;
    const poll = async () => {
      try {
        const res = await fetch("/api/super-admin/clients/notifications/unread-count", {
          headers: { Authorization: `Bearer ${localStorage.getItem("idToken")}` },
          credentials: "include",
        });
        if (!res.ok) return;
        const data = await res.json();
        if (!stop) setUnread(data.count || 0);
      } catch (_) { /* ignore transient errors */ }
    };
    poll();
    const t = setInterval(poll, 30000);
    return () => { stop = true; clearInterval(t); };
  }, []);

  return (
    <div
      style={{
        background: "#1e293b",
        padding: "12px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"   // ⭐ Push left + right apart
      }}
    >
      {/* LEFT SIDE NAV LINKS */}
      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <Link
          to="/super-admin"
          style={{ color: "white", textDecoration: "none", fontWeight: "bold" }}
        >
          CloudGenomics Admin
        </Link>

        <Link to="/super-admin/organizations" style={{ color: "white", textDecoration: "none" }}>
          Organizations
        </Link>

        <Link to="/super-admin/clients" style={{ color: "white", textDecoration: "none", position: "relative" }}>
          Clients
          {unread > 0 && (
            <span
              title={`${unread} outstanding client comment(s)`}
              style={{
                position: "absolute", top: -8, right: -14, background: "#ef4444", color: "#fff",
                borderRadius: "999px", fontSize: 11, fontWeight: 700, padding: "1px 6px", minWidth: 16, textAlign: "center"
              }}
            >
              {unread}
            </span>
          )}
        </Link>

        <Link to="/super-admin/billing" style={{ color: "white", textDecoration: "none" }}>
          Billing
        </Link>

        <Link to="/super-admin/resources" style={{ color: "white", textDecoration: "none" }}>
          Resources
        </Link>

        <Link to="/super-admin/create-organization" style={{ color: "white", textDecoration: "none" }}>
          Create Organization
        </Link>

        <Link to="/super-admin/settings" style={{ color: "white", textDecoration: "none" }}>
          Settings
        </Link>

        <Link to="/super-admin/prompts" style={{ color: "white", textDecoration: "none" }}>
          Prompts
        </Link>

        <Link to="/super-admin/ots" style={{ color: "white", textDecoration: "none" }}>
          Off-the-Shelf
        </Link>
      </div>

      {/* RIGHT SIDE LOGOUT BUTTON */}
      <button
        onClick={logout}
        style={{
          padding: "8px 14px",
          fontSize: "14px",
          cursor: "pointer",
          background: "#ef4444",
          color: "white",
          border: "none",
          borderRadius: "4px"
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default Navbar;
